import type { InstalledToolsFilterableField } from '@kirin/api-client/contracts/shadow-ai-installed-tools';
import { INSTALLED_TOOLS_FILTERABLE_FIELDS } from '@kirin/api-client/contracts/shadow-ai-installed-tools';
import { TABLE_IDS } from '@/components/DataTable/tableIds';

export const INSTALLED_TOOLS_FILTER_URL_KEYS = {
  [INSTALLED_TOOLS_FILTERABLE_FIELDS.NAME]: 'n',
  [INSTALLED_TOOLS_FILTERABLE_FIELDS.CATEGORY]: 'cat',
  [INSTALLED_TOOLS_FILTERABLE_FIELDS.RISK]: 'r',
  [INSTALLED_TOOLS_FILTERABLE_FIELDS.USERS]: 'uc',
  [INSTALLED_TOOLS_FILTERABLE_FIELDS.FIRST_DETECTED]: 'fd',
  [INSTALLED_TOOLS_FILTERABLE_FIELDS.LAST_SEEN]: 'ls',
  [INSTALLED_TOOLS_FILTERABLE_FIELDS.LOGGED_IN_USER]: 'liu',
} as const satisfies Record<InstalledToolsFilterableField, string>;

export const INSTALLED_TOOLS_TABLE_CONFIG = {
  tableId: TABLE_IDS.ORGANIZATION.SHADOW_AI.TOOLS,
} as const;
